/***
 * File name: subtable.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Subtypes in Notification
 * Types master data
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Data view for fetching different formatted data from the server
 * - Route definitions for different actions within the table
 * - Binded varibles
 * - Advanced query when fetching data list
 * - Name of the privilege for role restrictions
 * - Name of table columns indicated as fields
 * - Action buttons on top of the table indicated as tableActions
 * - Action buttons per item inside the table indicated as entryActions
 * - Breadcrumbs definition
 *
 */
// import ObjectId from 'bson-objectid'
export default function (vm) {
  return {
    name: 'SubNotificationTypeTable',
    collectionName: 'notificationType',
    dataView: 'default',
    label: 'Subtype',
    tableHeader: 'Subtypes',
    route: {
      updateMultiple: 'notificationType',
      list: 'notificationType',
      deleteMultiple: 'notificationType',
      upload: 'notificationType'
    },
    advancedQuery: {
      jurisdiction: vm.itemSelected
    },
    vBind: {
      singleSelect: true
    },
    // listFilter: (list) => {
    //   list.filter(x => x.jurisdiction === vm.itemSelected)
    // },
    hideSelect: true,
    privilege: 'canViewAllNotificationType',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'Subtype',
          value: 'value'
        }
      }
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Add',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: vm.itemSelected === 'xxx' ? '' : 'background-color: #162b54',
          disabled: vm.itemSelected === 'xxx'
        },
        privilege: 'canPostNotificationType',
        action: () => {
          vm.$emit('modalChange', 'create', 'subtype')
        }
      }
    ],
    entryActions: [
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewNotificationType',
        action: (item) => {
          vm.$emit('modalChange', 'view', 'subtype', item._id)
        }
      },
      {
        id: 'edit',
        icon: 'mdi-pencil',
        privilege: 'canViewNotificationType',
        action: (item) => {
          vm.$emit('editRow', 'edit', 'subtype', item._id)
        }
      },
      {
        id: 'del',
        icon: 'mdi-delete',
        privilege: 'canDeleteNotificationType',
        action: (item) => {
          vm.$emit('deleteRow', 'delete', 'subtype', item._id)
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'Notification Type'
        }
      ]
    }
  }
}
